<template>
  <!-- 日期范围选择器 -->
  <!-- 
    @change(beginTime, endTime, YMDDateList, MDDateList)
    【开始时间，结束时间，用于搜索的YMD格式列表，用于chart展示的MD格式列表】

    :beginTime
    :endTime
    开始时间 default: 8
    结束时间 default: 1
    用于自定义默认时间段（距离当前时间 X 天）

   -->
  <div>
    <a-range-picker
      v-model:value="dateRange"
      @change="onChange"
      :disabled-date="disabledDate"
      :allowClear="false"
    >
      <template #suffixIcon><CalendarOutlined /></template>
    </a-range-picker>
  </div>
</template>

<script>
import { CalendarOutlined } from '@ant-design/icons-vue'
import moment from 'moment'

const YMD = 'YYYY-MM-DD'
const MD = 'MM-DD'

export default {
  name: 'DateRangePicker',
  components: { CalendarOutlined },
  created() {
    this.onChange()
  },
  props: {
    beginTime: {
      type: Number,
      default: 8,
    },
    endTime: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      dateRange: [
        moment().subtract(this.beginTime, 'days'),
        moment().subtract(this.endTime, 'days'),
      ],
      disabledDate: (currentDate) => {
        return (
          currentDate.valueOf() < moment('2020-01-01').valueOf() ||
          currentDate.valueOf() > moment().valueOf()
        )
      },
    }
  },
  computed: {
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
    clientWidth() {
      return !this.isDesktop ? document.body.clientWidth : 552
    },
  },
  methods: {
    onChange() {
      const beginTime = moment(this.dateRange[0]).format(YMD)
      const endTime = moment(this.dateRange[1]).format(YMD)
      let YMDDateList = []
      let MDDateList = []
      for (let i = 0; ; i++) {
        const item = moment(this.dateRange[0]).add(i, 'days')
        YMDDateList.push(item.format(YMD))
        MDDateList.push(item.format(MD))
        if (item.format(YMD) === endTime) break
      }
      this.$emit('change', beginTime, endTime, YMDDateList, MDDateList)
    },
  },
}
</script>

<style>
.ant-calendar-range {
  width: var(--clientWidth);
  margin: 0 10px;
}
</style>
